import script from "./AdminIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIndex.vue?vue&type=script&setup=true&lang=js"

import "./AdminIndex.vue?vue&type=style&index=0&id=17107266&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17107266"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import Intersection from 'quasar/src/directives/intersection/Intersection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QPageSticky});qInstall(script, 'directives', {Intersection});
